export const fontStyles = {
  fontFamily: "Urbanist, Verdana, Arial, sans-serif",
  letterSpacing: "0.10em",
  color: "#3F5765",
};
